import SearchFilters from './SearchFilters';

export default SearchFilters;
